export default __webpack_public_path__ + "static/media/us-ak.c7b7274e.svg";